import './App.css';

function App() {
  const links = [
    ["Whatsapp", "https://wa.me/send?phone=5532991958593", 'img/whatsapp.png'],
    ["Instagram", "https://www.instagram.com/blackroseatelie/", 'img/instagram.png'],
    ["Youtube", "https://www.youtube.com/@blackroseatelie", 'img/youtube.svg'],
    ["Pinterest", "https://pin.it/5dgOjbu", 'img/pinterest.svg'],
    //["Cursos", "#", 'img/hotmart.png']
  ];

  function getLinks() {
    let t = links.length;
    let list = [];
    for (let i = 0 ; i < t ; i++) {
      list.push(
        <a href={links[i][1]} target={links[i][1] !== '#' ? "_blank" : '_self'} rel="noreferrer noopener">
          <div className='p-2 my-4 shadow-md bg-white rounded-full hover:scale-110 hover:transition-transform duration-500' style={{ border: "2px solid #777"}} key={i}>
            <span className='flex justify-center px-5'>
              <img className='flex-none' src={links[i][2]} alt="" style={{ width: '24px', height: '24px' }} />
              <span className='flex-grow font-serif pl-2'><b>{links[i][0]}</b></span>
            </span>
          </div>
        </a>
      );
    }
    return list;
  }

  return (
    <>
      <div className='text-center w-full'>

        <img className='rounded-full m-auto shadow-lg' src='img/logo.jpeg' width='150' height='150' style={{ marginTop: '70px', border: '4px solid #000' }} alt='Black Rose Ateliê' />

        <div className='font-bold font-serif m-4' style={{ fontSize: '1.2em'}}>
          @blackroseatelie<br/>
          <span style={{ fontSize: '0.8em'}}>Cíntia Coimbra</span>
        </div>

        <div className='w-full mx-auto mt-8 text-center px-5' style={{ minWidth: '200px', maxWidth: '700px' }}>
            { getLinks() }
        </div>
      </div>
    </>
  );
}

export default App;
